// // Modified code for PanelContent.js

// import React, { useState, useEffect, useRef } from 'react';
// import { SlidersHorizontal, Loader2, Target, Calendar, Map } from 'lucide-react';
// import CatalogImagery from './CatalogImagery';
// import TaskingConstellations from './TaskingConstellations';
// import SavedAOIs from './SavedAOIs';
// import * as turf from '@turf/turf';
// import { Tooltip } from '@mui/material';


// const CustomDropdown = ({ 
//   value = [], 
//   onChange, 
//   options, 
//   placeholder,
//   disabled = false 
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     }
//     if (isOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isOpen]);

//   const displayText = value.length > 0
//     ? options.filter(option => value.includes(option.value)).map(o => o.label).join(', ')
//     : placeholder;

//   const toggleOption = (selectedValue) => {
//     if (value.includes(selectedValue)) {
//       onChange(value.filter(v => v !== selectedValue));
//     } else {
//       onChange([...value, selectedValue]);
//     }
//   };

//   return (
//     <div ref={dropdownRef} style={{ position: 'relative', flex: 1 }}>
//       <div 
//         onClick={() => !disabled && setIsOpen(!isOpen)}
//         style={{
//           width: '100%',
//           backgroundColor: 'transparent',
//           border: 'none',
//           color: value.length > 0 ? '#A6B6CE' : '#A6B6CE',
//           fontSize: '13px',
//           cursor: disabled ? 'not-allowed' : 'pointer',
//           outline: 'none',
//           padding: '4px 0',
//           paddingRight: '0px',
//           backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23A6B6CE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
//           backgroundRepeat: 'no-repeat',
//           backgroundPosition: 'right center',
//         }}
//       >
//         {displayText}
//       </div>

//       {isOpen && (
//         <div 
//           style={{
//             position: 'absolute',
//             top: '100%',
//             left: 0,
//             width: '100%',
//             backgroundColor: 'rgba(22, 22, 22, 0.95)',
//             backdropFilter: 'blur(5px)',
//             borderRadius: '4px',
//             border: '1px solid rgba(166, 182, 206, 0.1)',
//             zIndex: 1000,
//             boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
//             maxHeight: '200px',
//             overflowY: 'auto'
//           }}
//         >
//           {options.map(option => (
//             <div
//               key={option.value}
//               onClick={() => toggleOption(option.value)}
//               style={{
//                 padding: '8px 10px',
//                 fontSize: '13px',
//                 color: '#A6B6CE',
//                 cursor: 'pointer',
//                 backgroundColor: value.includes(option.value) ? 'rgba(46, 144, 250, 0.2)' : 'transparent',
//                 transition: 'background-color 0.2s ease'
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = 'rgba(166, 182, 206, 0.1)';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = value.includes(option.value)
//                   ? 'rgba(46, 144, 250, 0.2)'
//                   : 'transparent';
//               }}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };


// const PanelContent = ({ 
//   activeTab,
//   onDateRangeChange,
//   imageryData,
//   onImageSelect,
//   selectedImages,
//   onImageHover,
//   onImageVisibilityToggle,
//   onSatelliteVisibilityToggle,
//   visibleImage,
//   onCheckOut,
//   onSaveDraft,
//   saveLoading = false,
//   error = null,
//   drawnCoordinates,
//   loading,
//   onFootprintSelect,
//   onSaveAOI,
//   onAOISelect,
//   onTaskingDataUpdate
// }) => {
//   const [catalogDates, setCatalogDates] = useState({
//     startDate: '',
//     endDate: ''
//   });
//   const [taskDates, setTaskDates] = useState({
//     startDate: '',
//     endDate: ''
//   });
  
//   const formData = activeTab === 'catalog' ? catalogDates : taskDates;
//   const [showFilters, setShowFilters] = useState(false);
//   const [showDraftOption, setShowDraftOption] = useState(false);
//   const [sensorType, setSensorType] = useState([]);
//   const [resolution, setResolution] = useState([]);
  
  
//   // New state variables for additional filters
//   const [maxCloudCover, setMaxCloudCover] = useState(100);
//   const [maxOffNadirAngle, setMaxOffNadirAngle] = useState(90);
//   const [maxSunElevation, setMaxSunElevation] = useState(90);
//   const [acquisitionMode, setAcquisitionMode] = useState('');
//   const [taskingSelection, setTaskingSelection] = useState(null);
//   const [loadingConstellation, setLoadingConstellation] = useState(null);
//   const overallCoverage = computeOverallCoverage();
  
//   const getFilteredImagery = () => {
//     const enhancedImagery = getEnhancedImagery();

//     return enhancedImagery.filter(item => {
//       // Sensor Type filter
//       if (sensorType.length > 0 && item.satellite) {
//         const isSAR = item.satellite.toLowerCase().includes('sar');
//         if (
//           (sensorType.includes('sar') && !isSAR) &&
//           !sensorType.includes('optical')
//         ) return false;
//         if (
//           (sensorType.includes('optical') && isSAR) &&
//           !sensorType.includes('sar')
//         ) return false;
//       }
      
//       if (resolution.length > 0 && item.resolution) {
//         const res = parseFloat(item.resolution);
//         const match = resolution.some(r => {
//           if (r === 'very-high') return res <= 0.5;
//           if (r === 'high') return res > 0.5 && res <= 2;
//           if (r === 'medium') return res > 2 && res <= 30;
//           if (r === 'low') return res > 30;
//           return false;
//         });
//         if (!match) return false;
//       }
      
      

//       // Additional filters
//       if (maxCloudCover < 100 && (item.cloud_cover > maxCloudCover)) return false;
      
//       if (maxOffNadirAngle < 90 && (item.off_nadir_angle > maxOffNadirAngle)) return false;
      
//       if (maxSunElevation < 90 && (item.sun_elevation > maxSunElevation)) return false;
      
//       if (acquisitionMode && item.acquisition_mode !== acquisitionMode) return false;
  
//       return true;
//     });
//   };
  
//   useEffect(() => {
//     setShowDraftOption(
//       imageryData && 
//       imageryData.length > 0 && 
//       (selectedImages || selectedImages.length === 0)
//     );
//   }, [imageryData, selectedImages]);

//   const getGuidanceMessage = () => {
//     if (!drawnCoordinates) {
//       return {
//         message: "Draw an Area of Interest (AOI) on the map to begin",
//         icon: <Target size={42} color="#2E90FA" style={{animation: 'pulse 2s infinite'}} />
//       };
//     }
//     if (!formData.startDate || !formData.endDate) {
//       return {
//         message: "Select a date range to search for available imagery",
//         icon: <Calendar size={100} color="#2E90FA" style={{animation: 'pulse 2s infinite'}} />
//       };
//     }
//     if (loading && activeTab === 'catalog') {
//       return {
//         message: "Searching for available imagery...",
//         icon: <Loader2 size={42} color="#2E90FA" style={{animation: 'spin 1s linear infinite'}} />
//       };
//     }
//     if (imageryData && imageryData.length === 0 && formData.startDate && formData.endDate && activeTab === 'catalog') {
//       return {
//         message: "No imagery found for the selected area and date range",
//         icon: <Map size={42} color="#A6B6CE" />
//       };
//     }
//     return null;
//   };

//   const guidance = getGuidanceMessage();

//   const startDateRef = useRef(null);
//   const endDateRef = useRef(null);

//   const handleDateChange = (fieldName, value) => {
//     if (!drawnCoordinates) return;
  
//     const isCatalog = activeTab === 'catalog';
//     const formDates = isCatalog ? catalogDates : taskDates;
//     const newFormData = { ...formDates, [fieldName]: value };
  
//     if (isCatalog) {
//       setCatalogDates(newFormData);
//     } else {
//       setTaskDates(newFormData);
//     }
  
//     // Only trigger on endDate change
//     if (fieldName === 'endDate' && newFormData.startDate && newFormData.endDate) {
//       onDateRangeChange(newFormData);
//     }
//   };
  
  
//   const calculateSummary = () => {
//     if (!selectedImages || selectedImages.length === 0) {
//       return {
//         count: 0,
//         constellations: [],
//         avgCloud: 0,
//         coverage: 0
//       };
//     }
  
//     const uniqueSatellites = [...new Set(selectedImages.map(img => img.satellite))];
//     return {
//       count: selectedImages.length,
//       constellations: uniqueSatellites,
//       avgCloud: selectedImages.reduce((sum, img) => sum + img.cloud_cover, 0) / selectedImages.length,
//       coverage: selectedImages.reduce((sum, img) => sum + (img.coverage_percentage || 0), 0)
//     };
//   };

//   const summary = calculateSummary();
//   const today = new Date().toISOString().split('T')[0];

//   function computeOverallCoverage() {
//     const aoiPolygon = getAOIPolygon();
//     const aoiArea = aoiPolygon ? turf.area(aoiPolygon) : 0;
//     if (!aoiPolygon || aoiArea === 0) return 0;
//     const intersections = selectedImages.map(tile => {
//       const tilePolygon = getTilePolygon(tile);
//       if (!tilePolygon) return null;
//       try {
//         const intersection = turf.intersect(turf.featureCollection([aoiPolygon, tilePolygon]));
//         return intersection;
//       } catch (error) {
//         console.error("Error computing intersection", error);
//         return null;
//       }
//     }).filter(intersection => intersection !== null);
//     if (intersections.length === 0) return 0;
//     let unionPoly = intersections[0];
//     for (let i = 1; i < intersections.length; i++) {
//       unionPoly = turf.union(turf.featureCollection([unionPoly, intersections[i]]));
//     }
//     if (!unionPoly) return 0;
//     const unionArea = turf.area(unionPoly);
//     return (unionArea / aoiArea) * 100;
//   }

//   const computeTaskingData = () => {
//     // Get the AOI polygon (assuming getAOIPolygon is defined in this file)
//     const aoiPolygon = getAOIPolygon();
//     const aoiArea =
//       aoiPolygon ? (turf.area(aoiPolygon) / 1000000).toFixed(2) : '0'; // area in sqkm
//     return {
//       constellationName: taskingSelection?.constellation?.name || '',
//       resolution: taskingSelection?.constellation?.resolution || '',
//       cloudCover: summary.avgCloud ? summary.avgCloud.toFixed(2) + '' : '10',
//       offNadirAngle: 0,
//       aoiArea: aoiArea,
//       coordinates : taskingSelection?.details?.opportunities?.map(opportunity => opportunity.footprint_coordinates)||"",
//       aoiCoverage: taskingSelection ? taskingSelection?.details?.areaCoverage : '0%',
//       estimatedTimeToCapture: taskingSelection?.details?.captureTimeRange || ''
//     };
//   };

//   useEffect(() => {
//     if (activeTab === 'task' && typeof onTaskingDataUpdate === 'function' && taskingSelection) {
//       const taskingData = computeTaskingData();
//       onTaskingDataUpdate(taskingData);
//     }
//   }, [activeTab, taskingSelection, drawnCoordinates]);

//   useEffect(() => {
    
//     if (activeTab === 'task') {
//       // Set custom hardcoded date values for task tab
//       const startDate = '2025-04-24'; // YYYY-MM-DD format
//       const endDate = '2025-05-06';   // YYYY-MM-DD format
      
//       // Update the state
//       setTaskDates({
//         startDate: startDate,
//         endDate: endDate
//       });
      
//       // If onDateRangeChange is provided, call it with the new values
//       if (onDateRangeChange) {
//         onDateRangeChange({
//           startDate: startDate,
//           endDate: endDate
//         });
//       }
//     }
//     else if (activeTab == 'catalog'){
//       const today = new Date();
//       const oneMonthAgo = new Date();
//       oneMonthAgo.setMonth(today.getMonth() - 1);
//       const startDate = oneMonthAgo.toISOString().split('T')[0];
//       const endDate = today.toISOString().split('T')[0];
      
//       console.log(startDate)
//       setCatalogDates({
//         startDate: startDate,
//         endDate: endDate
//       });
      
//       // If onDateRangeChange is provided, call it with the new values
//       if (onDateRangeChange) {
//         onDateRangeChange({
//           startDate: startDate,
//           endDate: endDate
//         });
//       }
//     }
//   }, [activeTab]);

//   if (activeTab === 'aois') {
//     return (
//       <SavedAOIs 
//         drawnCoordinates={drawnCoordinates}
//         onAOISelect={onAOISelect}
//       />
//     );
//   }

//   function getAOIPolygon() {
//     if (!drawnCoordinates || drawnCoordinates.length < 3) return null;
//     const coords = drawnCoordinates.map(coord => [coord.lng, coord.lat]);
//     if (coords[0][0] !== coords[coords.length - 1][0] ||
//         coords[0][1] !== coords[coords.length - 1][1]) {
//       coords.push(coords[0]);
//     }
//     return turf.polygon([coords]);
//   }
  
//   const aoiPolygon = getAOIPolygon();
//   const aoiArea = aoiPolygon ? turf.area(aoiPolygon) : 0;

//   // Function to calculate how much of the AOI is covered by a tile
//   const calculateTileCoverage = (tile) => {
//     if (!aoiPolygon || !tile.coordinates || tile.coordinates.length === 0) return 0;

//     const tileCoords = tile.coordinates[0];
//     // Ensure we have enough points to form a valid polygon
//     if (tileCoords.length < 3) {
//       console.warn('Tile coordinates do not have enough points to form a valid polygon', tile);
//       return 0;
//     }
    
//     // Ensure the polygon is closed
//     if (
//       tileCoords[0][0] !== tileCoords[tileCoords.length - 1][0] ||
//       tileCoords[0][1] !== tileCoords[tileCoords.length - 1][1]
//     ) {
//       tileCoords.push(tileCoords[0]);
//     }
    
//     // Additional validation: the closed ring should have at least 4 points
//     if (tileCoords.length < 4) return 0;
    
//     const tilePolygon = turf.polygon([tileCoords]);
    
//     // Use try/catch to handle any errors gracefully
//     let intersection;
//     try {
//       intersection = turf.intersect(turf.featureCollection([aoiPolygon, tilePolygon]));
//     } catch (error) {
//       console.error("Error during turf.intersect:", error);
//       return 0;
//     }
    
//     if (!intersection) return 0;
    
//     const intersectionArea = turf.area(intersection);
//     return (intersectionArea / aoiArea) * 100;
//   };
  
//   // Compute overall AOI coverage from selected tiles by summing their individual percentages
//   const totalCoverage = selectedImages.reduce((acc, tile) => {
//     return acc + calculateTileCoverage(tile);
//   }, 0);

//   const getEnhancedImagery = () => {
//     if (!imageryData) return [];
  
//     // First, get the AOI polygon from drawnCoordinates
//     const aoiPolygon = getAOIPolygon();
//     const aoiArea = aoiPolygon ? turf.area(aoiPolygon) : 0;
  
//     return imageryData.map(item => {
//       // Calculate coverage percentage only if AOI exists
//       const coveragePercentage = aoiPolygon && aoiArea > 0 ? calculateTileCoverage(item) : 0;
//       return {
//         ...item,
//         coveragePercentage, // attach the computed percentage
//       };
//     });
//   };

//   // Helper: Convert tile coordinates to a Turf polygon
//   function getTilePolygon(tile) {
//     if (!tile.coordinates || tile.coordinates.length === 0) return null;
//     const tileCoords = tile.coordinates[0];
//     if (tileCoords.length < 3) {
//       console.warn('Tile coordinates do not have enough points to form a valid polygon', tile);
//       return null;
//     }
//     // Ensure the polygon is closed
//     if (
//       tileCoords[0][0] !== tileCoords[tileCoords.length - 1][0] ||
//       tileCoords[0][1] !== tileCoords[tileCoords.length - 1][1]
//     ) {
//       tileCoords.push(tileCoords[0]);
//     }
//     if (tileCoords.length < 4) return null;
//     return turf.polygon([tileCoords]);
//   }

//   // In the renderSummaryContent function in PanelContent.js
//   const renderSummaryContent = () => {
//     // If feasibility is being checked, show loading or empty state
//     if (activeTab === 'task' && loadingConstellation) {
//       return [
//         ['Constellations:', '-'],
//         ['Estimated No. of strips:', '-'],
//         ['% Area covered of AOI:', '-'],
//         ['Estimated Time to Capture:', '-']
//       ];
//     }

//     // If a constellation is selected and has details, show those details
//     if (activeTab === 'task' && taskingSelection) {
//       const { constellation, details } = taskingSelection;
//       return [
//         ['Constellations:', constellation?.name || '-'],
//         ['Estimated No. of strips:', details?.opportunities?.length || '-'],
//         ['% Area covered of AOI:', details?.areaCoverage || '-'],
//         ['Estimated Time to Capture:', details?.captureTimeRange || '-']
//       ];
//     }

//     // Default case for catalog tab or no selection
//     return [
//       ['No. of images:', summary.count || '-'],
//       ['Constellations:', summary.constellations.join(', ') || '-'],
//       ['Avg. Cloud Cover:', `${summary.avgCloud.toFixed(2)}%`],
//       ['% Area covered of AOI:', `${overallCoverage.toFixed(2)}%`]
//     ];
//   };

//   // Modify the Summary Section buttons
//   const renderActionButtons = () => {
//     if (activeTab === 'task') {
//       return (
//         <>
//           <div style={{
//             fontSize: '13px',
//             fontStyle: 'italic',
//             color: '#A6B6CE',
//             marginBottom: '12px',
//             opacity: 0.8
//           }}>
//             Disclaimer: All estimates are subject to change.
//           </div>
//           <Tooltip 
//   title="This feature is still in development and is for illustration purposes." 
//   arrow 
//   PopperProps={{
//     modifiers: [
//       {
//         name: 'zIndex',
//         enabled: true,
//         phase: 'write',
//         fn({ state }) {
//           state.styles.popper.zIndex = 10000;  // Force higher zIndex
//         },
//       },
//     ],
//   }}
//   componentsProps={{
//     tooltip: {
//       sx: {
//         fontSize: '14px',  // Change this value to adjust text size
//       }
//     }
//   }}
// >
//   <span style={{ width: '100%' }}>
//     <button 
//       disabled
//       style={{
//         width: '100%',
//         backgroundColor: '#666666',
//         color: '#A6B6CE',
//         padding: '12px',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '16px',
//         cursor: 'not-allowed',
//         opacity: 0.5,
//         fontWeight: '500',
//         transition: 'all 0.3s ease'
//       }}
//     >
//       Add to Cart
//     </button>
//   </span>
// </Tooltip>

//         </>
//       );
//     }

//     return (
//       <div style={{ display: 'flex', gap: '10px' }}>
//         {showDraftOption && (
//           <button 
//             onClick={onSaveDraft}
//             disabled={saveLoading || !selectedImages.length}
//             style={{
//               flex: 1,
//               backgroundColor: 'transparent',
//               color: '#2E90FA',
//               padding: '12px',
//               border: 'none',
//               borderRadius: '8px',
//               fontSize: '16px',
//               cursor: saveLoading || !selectedImages.length ? 'not-allowed' : 'pointer',
//               fontWeight: '500',
//               opacity: saveLoading || !selectedImages.length ? 0.5 : 1,
//               transition: 'opacity 0.3s ease'
//             }}
//           >
//             {saveLoading ? 'Saving...' : 'Save order as draft'}
//           </button>
//         )}
//         <button 
//           onClick={onCheckOut}
//           disabled={!selectedImages.length}
//           style={{
//             flex: 1,
//             backgroundColor: selectedImages.length ? '#2E90FA' : '#666666',
//             color: '#ffffff',
//             padding: '12px',
//             border: 'none',
//             borderRadius: '8px',
//             fontSize: '16px',
//             cursor: selectedImages.length ? 'pointer' : 'not-allowed',
//             opacity: selectedImages.length ? 1 : 0.5,
//             fontWeight: '500',
//             transition: 'all 0.3s ease'
//           }}
//         >
//           Check Out
//         </button>
//       </div>
//     );
//   };
  
//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', height: '100%', color: '#A6B6CE' }}>
//       <style>
//         {`
//           @keyframes pulse {
//             0% { opacity: 1; }
//             50% { opacity: 0.1; }
//             100% { opacity: 1; }
//           }
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//                       /* This targets the calendar icon in date inputs in supported browsers */
//           input[type="date"]::-webkit-calendar-picker-indicator {
//             filter: invert(1);
//             opacity: 1;
//             cursor: pointer;
//           }
          
//           /* This is for Firefox and other browsers */
//           input[type="date"] {
//             color-scheme: light;
//           }
//         `}
//       </style>

//       {/* Guidance Message at the top when no AOI is drawn */}
//       {!drawnCoordinates && (
//         <div style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: '20px',
//           textAlign: 'center',
//           backgroundColor: 'rgba(46, 144, 250, 0.05)',
//           borderRadius: '8px',
//           margin: '10px 16px',
//           border: '1px solid rgba(46, 144, 250, 0.2)'
//         }}>
//           <div style={{ fontSize: '32px', marginBottom: '16px' }}>
//             <Target size={42} color="#2E90FA" style={{animation: 'pulse 2s infinite'}} />
//           </div>
//           <div style={{ fontSize: '20px', color: '#A6B6CE',animation: 'pulse 2s infinite' }} >
//             Draw an Area of Interest (AOI) on the map to begin
//           </div>
//         </div>
//       )}

//       {/* Date Range and Filters */}
//       <div style={{ 
//         padding: '10px 10px 10px 16px', 
//         borderBottom: '1px solid #00000080',
//         opacity: drawnCoordinates ? 1 : 0.5,
//         pointerEvents: drawnCoordinates ? 'auto' : 'none',
//         transition: 'opacity 0.3s ease'
//       }}>
//         {/* Date Range Input */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
//           <span style={{ fontSize: '14px', color: '#A6B6CE', whiteSpace: 'nowrap' ,fontWeight: 'bold'}}>Date Range</span>
//           <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
//             {/* Start Date Field */}
//             <div
//               style={{ position: 'relative', width: '120px', cursor: 'pointer' }}
//               onMouseDown={(e) => e.preventDefault()} // Prevents text selection
//               onClick={() => {
//                 if (startDateRef.current && startDateRef.current.showPicker) {
//                   startDateRef.current.showPicker();
//                 } else {
//                   startDateRef.current.focus();
//                 }
//               }}
//             >
//               {!formData.startDate && (
//                 <div style={{
//                   position: 'absolute',
//                   left: '10px',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   fontSize: '13px',
//                   color: '#A6B6CE',
//                   fontWeight: 'bold',
//                   pointerEvents: 'none'
//                 }}>
//                   Start
//                 </div>
//               )}
//               <input
//                 ref={startDateRef}
//                 type="date"
//                 max={activeTab === 'catalog' ? today : undefined}
//                 min={activeTab === 'task' ? today : undefined}
//                 value={formData.startDate}
//                 onChange={(e) => handleDateChange('startDate', e.target.value)}
//                 style={{
//                   backgroundColor: 'transparent',
//                   border: 'none',
//                   fontWeight: 'bold',
//                   color: formData.startDate ? '#A6B6CE' : 'transparent', // Changed from #A6B6CE to #A6B6CE
//                   cursor: drawnCoordinates ? 'pointer' : 'not-allowed', // Show disabled cursor
//                   outline: 'none',
//                   fontSize: '13px',
//                   width: '100%',
//                   padding: '5px',
//                 }}
//               />
//             </div>
//             <div
//               style={{ position: 'relative', width: '120px', cursor: 'pointer' ,fontWeight: 'bold'}}
//               onMouseDown={(e) => e.preventDefault()} // Prevents text selection
//               onClick={() => {
//                 if (endDateRef.current && endDateRef.current.showPicker) {
//                   endDateRef.current.showPicker();
//                 } else {
//                   endDateRef.current.focus();
//                 }
//               }}
//             >
//               {!formData.endDate && (
//                 <div style={{
//                   position: 'absolute',
//                   left: '10px',
//                   fontWeight: 'bold',
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   fontSize: '13px',
//                   color: '#A6B6CE',
//                   pointerEvents: 'none'
//                 }}>
//                   End
//                 </div>
//               )}
//               <input
//                 ref={endDateRef}
//                 type="date"
//                 max={activeTab === 'catalog' ? today : undefined}
//                 min={activeTab === 'task' ? today : undefined}
//                 value={formData.endDate}
//                 onChange={(e) => {
//                   const newEndDate = e.target.value;
//                   if (!formData.startDate || newEndDate >= formData.startDate) {
//                     handleDateChange('endDate', newEndDate);
//                   }
//                 }}
//                 style={{
//                   backgroundColor: 'transparent',
//                   border: 'none',
//                   fontWeight: 'bold',
//                   color: formData.endDate ? '#A6B6CE' : 'transparent', // Changed from #A6B6CE to #A6B6CE
//                   cursor: drawnCoordinates ? 'pointer' : 'not-allowed', // Show disabled cursor
//                   outline: 'none',
//                   fontSize: '13px',
//                   width: '100%',
//                   padding: '5px'
//                 }}
//               />
              
//             </div>
//             <button
//   onClick={() => {
//     if (formData.startDate && formData.endDate && drawnCoordinates) {
//       onDateRangeChange(formData);
//     }
//   }}
//   style={{
//     marginLeft: '17px',
//     padding: '6px 12px',
//     fontSize: '13px',
//     backgroundColor: '#2E90FA',
//     color: 'white',
//     border: 'none',
//     borderRadius: '4px',
//     cursor: 'pointer',
//     fontWeight: 'bold'
//   }}
// >
//   Go
// </button>

//           </div>
//         </div>
//         <div style={{ height: '10px' }}></div>
//         {/* Sensor and Resolution Filters */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '12px', position: 'relative' }}>
//         <CustomDropdown
//   value={sensorType}
//   onChange={setSensorType}
//   options={[
//     { value: 'optical', label: 'Optical' },
//     { value: 'sar', label: 'SAR' }
//   ]}
//   placeholder="Sensor Type"
//   disabled={!drawnCoordinates}
// />

// <CustomDropdown
//   value={resolution}
//   onChange={setResolution}
//   options={[
//     { value: 'very-high', label: 'Very high (≤50cm)' },
//     { value: 'high', label: 'High (>50cm & ≤2m)' },
//     { value: 'medium', label: 'Medium (>2m and ≤30m)' },
//     { value: 'low', label: 'Low (>30m)' }
//   ]}
//   placeholder="Resolution"
//   disabled={!drawnCoordinates}
// />


//           {/* Additional Filters Dropdown */}
//           <div style={{
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             height: '10px',
//             position: 'relative'
//           }}>
//             <SlidersHorizontal size={20} style={{ color: '#A6B6CE' }} onClick={() => setShowFilters(!showFilters)} />
//             {showFilters && (
//               <div style={{
//                 position: 'absolute',
//                 right: 0,
//                 top: '100%',
//                 marginTop: '8px',
//                 width: '250px',
//                 backgroundColor: '#1F1F1F',
//                 borderRadius: '4px',
//                 padding: '12px',
//                 zIndex: 50,
//                 boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
//               }}>
//                 <h3 style={{ fontSize: '14px', color: '#A6B6CE', marginBottom: '12px', marginTop: '4px' }}>
//                   Additional Filters
//                 </h3>
//                 {[
//                   { 
//                     label: 'Max Cloud Cover %', 
//                     value: maxCloudCover,
//                     onChange: setMaxCloudCover,
//                     type: 'number',
//                     min: 0,
//                     max: 100,
//                     placeholder: 'Cloud cover %'
//                   },
//                   { 
//                     label: 'Max Off Nadir Angle', 
//                     value: maxOffNadirAngle,
//                     onChange: setMaxOffNadirAngle,
//                     type: 'number',
//                     min: 0,
//                     max: 90,
//                     placeholder: 'Off nadir angle'
//                   },
//                   { 
//                     label: 'Max Sun Elevation', 
//                     value: maxSunElevation,
//                     onChange: setMaxSunElevation,
//                     type: 'number',
//                     min: 0,
//                     max: 90,
//                     placeholder: 'Sun elevation'
//                   },
//                   // { 
//                   //   label: 'Acquisition Mode', 
//                   //   value: acquisitionMode,
//                   //   onChange: setAcquisitionMode,
//                   //   type: 'select',
//                   //   options: [
//                   //     { value: '', label: 'Any' },
//                   //     { value: 'strip', label: 'Strip' },
//                   //     { value: 'scene', label: 'Scene' }
//                   //   ]
//                   // }
//                 ].map((filter) => (
//                   <div key={filter.label} style={{ 
//                     display: 'flex', 
//                     justifyContent: 'space-between', 
//                     alignItems: 'center', 
//                     marginBottom: '10px' 
//                   }}>
//                     <span style={{ fontSize: '13px', color: '#A6B6CE' }}>{filter.label}</span>
//                     {filter.type === 'select' ? (
//                       <select 
//                         value={filter.value}
//                         onChange={(e) => filter.onChange(e.target.value)}
//                         style={{ 
//                           backgroundColor: 'transparent',
//                           border: 'none', 
//                           color: '#A6B6CE', 
//                           fontSize: '13px', 
//                           cursor: 'pointer', 
//                           outline: 'none' 
//                         }}
//                       >
//                         {filter.options.map((option) => (
//                           <option 
//                             key={option.value} 
//                             value={option.value}
//                           >
//                             {option.label}
//                           </option>
//                         ))}
//                       </select>
//                     ) : (
//                       <input 
//                         type={filter.type}
//                         value={filter.value}
//                         min={filter.min}
//                         max={filter.max}
//                         placeholder={filter.placeholder}
//                         onChange={(e) => filter.onChange(Number(e.target.value))}
//                         style={{ 
//                           width: '100px',
//                           backgroundColor: 'transparent',
//                           border: '1px solid rgba(166, 182, 206, 0.2)', 
//                           color: '#A6B6CE', 
//                           fontSize: '13px', 
//                           padding: '4px',
//                           borderRadius: '4px',
//                           outline: 'none' 
//                         }}
//                       />
//                     )}
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Main Content Area */}
//       <div style={{ 
//         flex: 1,
//         padding: '0 16px 16px 16px', 
//         borderBottom: '1px solid #00000080',
//         minHeight: '200px',
//         maxHeight: 'calc(100vh - 400px)',
//         overflow: 'auto',
//         scrollbarWidth: 'thin',
//         scrollbarColor: 'rgba(255,255,255,0.1) transparent',
//         '&::-webkit-scrollbar': {
//           width: '2px',
//           backgroundColor: 'transparent'
//         },
//         '&::-webkit-scrollbar-track': {
//           backgroundColor: 'transparent'
//         },
//         '&::-webkit-scrollbar-thumb': {
//           backgroundColor: 'rgba(255,255,255,0.1)',
//           borderRadius: '1px'
//         },
//         '&::-webkit-scrollbar-thumb:hover': {
//           backgroundColor: 'rgba(255,255,255,0.2)'
//         }
//       }}>
//         {/* Error Handling and Guidance - Now we only show guidance here for non-AOI messages */}
//         {drawnCoordinates && guidance ? (
//           <div style={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             justifyContent: 'center',
//             height: '100%',
//             textAlign: 'center',
//             color: '#A6B6CE',
//             padding: '20px'
//           }}>
//             <div style={{ fontSize: '32px', marginBottom: '16px' }}>{guidance.icon}</div>
//             <div style={{ fontSize: '20px' }}>{guidance.message}</div>
//           </div>
//         ) : error ? (
//           <div style={{
//             color: '#FF4D4F',
//             padding: '10px',
//             backgroundColor: 'rgba(255,77,79,0.1)',
//             borderRadius: '4px',
//             textAlign: 'center',
//             margin: '10px'
//           }}>
//             {error}
//           </div>
//         ) : (
//           activeTab === 'catalog' ? (
//             <CatalogImagery 
//               items={getFilteredImagery()} 
//               onImageSelect={onImageSelect}
//               onVisibilityToggle={onImageVisibilityToggle}
//               onSatelliteVisibilityToggle={onSatelliteVisibilityToggle}
//               onImageHover={onImageHover}
//               visibleImage={visibleImage}
//               drawnCoordinates={drawnCoordinates}
//             />
//           ) : activeTab === 'task' ? (
//             <TaskingConstellations 
//               dateRange={formData} 
//               drawnCoordinates={drawnCoordinates} 
//               onFootprintSelect={onFootprintSelect}
//               onSelectionChange={setTaskingSelection}
//               loadingHandler={(loading) => setLoadingConstellation(loading)}
//             />
//           ) : null
//         )}
//       </div>

//       {/* Summary Section */}
//       <div style={{ padding: '16px', marginTop: 'auto' }}>
//         <h3 style={{ 
//           fontSize: '16px', 
//           color: '#A6B6CE', 
//           fontWeight: 'normal', 
//           marginBottom: '12px', 
//           marginTop: '4px' 
//         }}>
//           Your Selection
//         </h3>

//         <div style={{ marginBottom: '16px' }}>
//           {renderSummaryContent().map(([label, value]) => (
//             <div key={label} style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               fontSize: '13px', 
//               color: '#A6B6CE', 
//               marginBottom: '4px' 
//             }}>
//               <span>{label}</span>
//               <span>{value}</span>
//             </div>
//           ))}
//         </div>

//         {renderActionButtons()}
//       </div>
//     </div>
//   );
// };

// export default PanelContent;

// Modified code for PanelContent.js

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { SlidersHorizontal, Loader2, Target, Calendar, Map, Settings } from 'lucide-react';
import CatalogImagery from './CatalogImagery';
import TaskingConstellations from './TaskingConstellations';
import SavedAOIs from './SavedAOIs';
import * as turf from '@turf/turf';
import ResolutionSliderDropdown from './ResolutionSliderDropdown';
import axios from 'axios';
import { USER_URLS, SEARCH_URLS } from '../config/urls';
import { Box, Slider, Tooltip, Button, IconButton, Typography, Checkbox } from '@mui/material';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./dark-datepicker.css";
import SatelliteLegend from './SatelliteLegend';
import DateRangePicker from "./DateRangePicker";
import ConstellationFilter from "./ConstellationFilter";
import ReactDOM from 'react-dom';

const CustomDropdown = ({
  value = [], 
  onChange, 
  options, 
  placeholder,
  disabled = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const displayText = value.length > 0
    ? options.filter(option => value.includes(option.value)).map(o => o.label).join(', ')
    : placeholder;

  const toggleOption = (selectedValue) => {
    if (value.includes(selectedValue)) {
      onChange(value.filter(v => v !== selectedValue));
    } else {
      onChange([...value, selectedValue]);
    }
  };

  return (
    <div ref={dropdownRef} style={{ position: 'relative', flex: 1 }}>
      <div 
        onClick={() => !disabled && setIsOpen(!isOpen)}
        style={{
          width: '100%',
          backgroundColor: 'transparent',
          border: 'none',
          color: value.length > 0 ? '#A6B6CE' : '#A6B6CE',
          fontSize: '13px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          outline: 'none',
          padding: '4px 0',
          paddingRight: '0px',
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23A6B6CE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right center',
        }}
      >
        {displayText}
      </div>

      {isOpen && (
        <div 
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            width: '100%',
            backgroundColor: 'rgba(22, 22, 22, 0.95)',
            backdropFilter: 'blur(5px)',
            borderRadius: '4px',
            border: '1px solid rgba(166, 182, 206, 0.1)',
            zIndex: 1000,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
            maxHeight: '200px',
            overflowY: 'auto'
          }}
        >
          {options.map(option => (
            <div
              key={option.value}
              onClick={() => toggleOption(option.value)}
              style={{
                padding: '8px 10px',
                fontSize: '13px',
                color: '#A6B6CE',
                cursor: 'pointer',
                backgroundColor: value.includes(option.value) ? 'rgba(46, 144, 250, 0.2)' : 'transparent',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(166, 182, 206, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = value.includes(option.value)
                  ? 'rgba(46, 144, 250, 0.2)'
                  : 'transparent';
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


const PanelContent = ({
onRegisterReset,
  activeTab,
  onDateRangeChange,
  dateRange,
  imageryData,
  onImageSelect,
  selectedImages,
  onImageHover,
  onImageVisibilityToggle,
  onSatelliteVisibilityToggle,
  visibleImage,
  onCheckOut,
  onSaveDraft,
  saveLoading = false,
  error = null,
  drawnCoordinates,
  setDrawnCoordinates,
  loading,
  onFootprintSelect,
  onSaveAOI,
  onAOISelect,
  onTaskingDataUpdate,
  onSearch,
  isDrawing,
  isRestoringTaskingState = false,
  cachedTaskingState = null,
  onTaskingStateReady,
  onFeasibilityTriggerReady,
  onClearSelectionsReady,
    // satelliteLegend Items
  // groupedItems,
  // satelliteSelections,
  // handleSelectAllForSatellite,
  // getRandomColor

}) => {
  // Use centralized dateRange prop - no local state needed
  // dateRange is managed by parent (ExplorePage) and is the single source of truth
const getVal = (v) => (v && (v.value ?? v)) ?? v;

const [groupedItems, setGroupedItems] = useState({});
const [satelliteSelections, setSatelliteSelections] = useState({});
const [handleSelectAllForSatellite, setHandleSelectAllForSatellite] = useState(() => () => {});
const [satelliteColors, setSatelliteColors] = useState({});

  // Constellation filter state (from development branch)
  const [constellationFilter, setConstellationFilter] = useState([]);
  const [taskConstellations, setTaskConstellations] = useState([]);
  const [enabledTaskConstellations, setEnabledTaskConstellations] = useState([]);
  const [constellationsWithStrips, setConstellationsWithStrips] = useState([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedConstellationsForExport, setSelectedConstellationsForExport] = useState([]);
  const [exportFormat, setExportFormat] = useState('xlsx'); // 'xlsx' or 'csv'

  const availableConstellations = useMemo(() => {
    if (activeTab === "catalog") {
      if (!imageryData) return [];
      return [...new Set(imageryData.map(i => i.satellite))].filter(Boolean);
    }

    if (activeTab === "task") {
      return taskConstellations;   // Use the real data
    }

    return [];
  }, [activeTab, imageryData, taskConstellations]);

  useEffect(() => {
    if (availableConstellations.length > 0) {
      setConstellationFilter(availableConstellations);
    }
  }, [availableConstellations]);

  // Auto-select all constellations when the list first becomes available,
  // but do NOT overwrite user selections or clear selections when the list is empty.
  useEffect(() => {
    if (!Array.isArray(availableConstellations)) return;

    // If we don't have any constellations yet, do nothing.
    if (availableConstellations.length === 0) return;

    setConstellationFilter(prev => {
      // If prev already contains exactly the same constellation names, keep it.
      if (prev.length === availableConstellations.length) {
        const prevSet = new Set(prev);
        const same = availableConstellations.every(c => prevSet.has(c));
        if (same) return prev;
      }

      // If user already made manual selections (prev is non-empty and not identical),
      // don't stomp them — but if prev is empty we assume first-load and set all.
      if (prev.length > 0) {
        // Preserve user selection
        return prev;
      }

      // Default: set to all available constellations
      return [...availableConstellations];
    });
  }, [availableConstellations]);

  // Handle task constellation toggle
  const handleTaskConstellationToggle = (name, value) => {
    // Hide constellation footprints on uncheck
    if (!value) {
      onFootprintSelect?.({
        coordinates: [],
        color: null,
        constellation: name
      });
    }
  };

  // Use centralized dateRange prop for form data
  // If dateRange is not set yet, use empty strings as fallback
  const formData = dateRange || { startDate: '', endDate: '' };
  const [showFilters, setShowFilters] = useState(false);
  const [showDraftOption, setShowDraftOption] = useState(false);
  const [sensorType, setSensorType] = useState([]);
  const [resolution, setResolution] = useState([]);
  const [resolutionRange, setResolutionRange] = useState([0, 100]); // in meters

  // Resolution range reset logic (from development branch)
  useEffect(() => {
    if (activeTab === "catalog") {
      setResolutionRange([0, 50]);   // Reset for catalog
      setCommittedResolutionRange([0, 50]);
    }

    if (activeTab === "task") {
      setResolutionRange([0, 3]);    // Reset for task
      setCommittedResolutionRange([0, 3]);
    }
  }, [activeTab]);

// const [drawnCoordinates, setDrawnCoordinates] = useState([]);


  // New state variables for additional filters
  const [maxCloudCover, setMaxCloudCover] = useState(100);
  const [maxOffNadirAngle, setMaxOffNadirAngle] = useState(25); // hard cap at 25°
  const [maxSunElevation, setMaxSunElevation] = useState(0);    // min sun elevation starts at 0°
  const [acquisitionMode, setAcquisitionMode] = useState('');
  const [taskingSelection, setTaskingSelection] = useState(null);
  const [loadingConstellation, setLoadingConstellation] = useState(null);
  const [userRole, setUserRole] = useState('');
  const overallCoverage = computeOverallCoverage();

  // Committed filter values (only update when user releases slider or changes dropdown)
  // This prevents unnecessary resets during slider dragging
  const [committedResolutionRange, setCommittedResolutionRange] = useState([0, 100]);
  const [committedMaxOffNadirAngle, setCommittedMaxOffNadirAngle] = useState(25);
  const [committedMaxSunElevation, setCommittedMaxSunElevation] = useState(0);
  const [committedSensorType, setCommittedSensorType] = useState([]);
  const [committedAcquisitionMode, setCommittedAcquisitionMode] = useState('');

  // Ref to store feasibility trigger function from TaskingConstellations
  const feasibilityTriggerRef = useRef(null);
  const clearSelectionsRef = useRef(null);


    useEffect(() => {
      // Listen for new AOI updates from anywhere in the app
      const handleAOIUpdate = (e) => {
        const { coordinates } = e.detail;
        console.log('🗺️ AOI updated from map:', coordinates);
        setDrawnCoordinates(coordinates);

        // ✅ Trigger date-based data refresh automatically if both dates are set
        // BUT: On tasking tab, don't trigger onDateRangeChange (which would trigger search)
        // Instead, feasibility will be triggered directly from ExplorePage when drawing completes
        if (coordinates && dateRange && dateRange.startDate && dateRange.endDate && activeTab !== 'task') {
          console.log('🔄 Triggering onDateRangeChange due to new AOI (catalog tab)');
          onDateRangeChange(dateRange);
        } else if (activeTab === 'task') {
          console.log('⏸️ Skipping onDateRangeChange - on tasking tab, feasibility will be triggered from ExplorePage');
        }
      };

      window.addEventListener('aoiCoordinatesUpdated', handleAOIUpdate);

      return () => {
        window.removeEventListener('aoiCoordinatesUpdated', handleAOIUpdate);
      };
    }, [activeTab, dateRange, onDateRangeChange]);


  // Fetch user role on component mount
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(USER_URLS.getMe, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUserRole(response.data.role || '');
      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };

    fetchUserRole();
  }, []);

  // No local date state - we use the centralized dateRange prop directly
  // The parent (ExplorePage) manages dateRange and updates it on tab switch

  // Helper functions (must be defined before getFilteredImagery)
  function getAOIPolygon() {
    if (!drawnCoordinates || drawnCoordinates.length < 3) return null;
    const coords = drawnCoordinates.map(coord => [coord.lng, coord.lat]);
    if (coords[0][0] !== coords[coords.length - 1][0] ||
        coords[0][1] !== coords[coords.length - 1][1]) {
      coords.push(coords[0]);
    }
    return turf.polygon([coords]);
  }

  const aoiPolygon = getAOIPolygon();
  const aoiArea = aoiPolygon ? turf.area(aoiPolygon) : 0;

  // Function to calculate how much of the AOI is covered by a tile
  const calculateTileCoverage = (tile) => {
    if (!aoiPolygon || !tile.coordinates || tile.coordinates.length === 0) return 0;

    const tileCoords = tile.coordinates[0];
    // Ensure we have enough points to form a valid polygon
    if (tileCoords.length < 3) {
      console.warn('Tile coordinates do not have enough points to form a valid polygon', tile);
      return 0;
    }

    // Ensure the polygon is closed
    if (
      tileCoords[0][0] !== tileCoords[tileCoords.length - 1][0] ||
      tileCoords[0][1] !== tileCoords[tileCoords.length - 1][1]
    ) {
      tileCoords.push(tileCoords[0]);
    }

    // Additional validation: the closed ring should have at least 4 points
    if (tileCoords.length < 4) return 0;

    const tilePolygon = turf.polygon([tileCoords]);

    // Use try/catch to handle any errors gracefully
    let intersection;
    try {
      intersection = turf.intersect(turf.featureCollection([aoiPolygon, tilePolygon]));
    } catch (error) {
      console.error("Error during turf.intersect:", error);
      return 0;
    }

    if (!intersection) return 0;

    const intersectionArea = turf.area(intersection);
    return (intersectionArea / aoiArea) * 100;
  };

  const getEnhancedImagery = () => {
    if (!imageryData) return [];

    // First, get the AOI polygon from drawnCoordinates
    const aoiPolygon = getAOIPolygon();
    const aoiArea = aoiPolygon ? turf.area(aoiPolygon) : 0;

    return imageryData.map(item => {
      // Calculate coverage percentage only if AOI exists
      const coveragePercentage = aoiPolygon && aoiArea > 0 ? calculateTileCoverage(item) : 0;
      return {
        ...item,
        coveragePercentage, // attach the computed percentage
      };
    });
  };

  const getFilteredImagery = () => {
    const enhancedImagery = getEnhancedImagery();

    return enhancedImagery.filter(item => {
      // Sensor Type filter
      if (sensorType.length > 0 && item.satellite) {
        const isSAR = item.satellite.toLowerCase().includes('sar') ||
                      item.satellite.toLowerCase().includes('sentinel-1');        if (
          (sensorType.includes('sar') && !isSAR) &&
          !sensorType.includes('optical')
        ) return false;
        if (
          (sensorType.includes('optical') && isSAR) &&
          !sensorType.includes('sar')
        ) return false;
      }

      if (item.resolution) {
        const res = parseFloat(item.resolution);
        if (res < resolutionRange[0] || res > resolutionRange[1]) return false;
      }





      // Additional filters
      if (maxCloudCover < 100 && (item.cloud_cover > maxCloudCover)) return false;

      // Max off-nadir angle (0–25°). Filter out anything above the slider value.
      if (item.off_nadir_angle != null && item.off_nadir_angle > maxOffNadirAngle) return false;

      // Min sun elevation (0–90°). Increase slider to require higher sun elevation.
      if (maxSunElevation < 90 && item.sun_elevation != null && item.sun_elevation < maxSunElevation) return false;

      if (acquisitionMode && item.acquisition_mode !== acquisitionMode) return false;

      return true;
    });
  };

  // Enabled constellations (for filtering UI) - must be after getFilteredImagery
  const enabledConstellations = useMemo(() => {
    if (activeTab === "catalog") {
      // Satellites present AFTER all filters
      const filtered = getFilteredImagery();
      return [...new Set(filtered.map(i => i.satellite))];
    }
    if (activeTab === "task") {
      // Only the constellations that have strips (opportunities)
      return enabledTaskConstellations;
    }
    return [];
  }, [
    activeTab,
    enabledTaskConstellations,
    // all filter dependencies
    sensorType,
    resolutionRange,
    maxCloudCover,
    maxOffNadirAngle,
    maxSunElevation,
    acquisitionMode,
    imageryData
  ]);

  useEffect(() => {
    // Skip for tasking tab - handled separately
    if (activeTab === 'task') return;
    
    if (enabledConstellations.length === 0) return;
    
    // Only set constellationFilter from enabledConstellations if:
    // 1. constellationFilter is empty (initial load), OR
    // 2. The enabledConstellations list has changed significantly (new constellations added/removed)
    // But preserve user's manual selections
    setConstellationFilter(prev => {
      // If user already made manual selections, preserve them
      if (prev.length > 0) {
        // Only update if enabledConstellations contains constellations not in prev
        // This allows new constellations to be added, but preserves unchecked ones
        const prevSet = new Set(prev);
        const newConstellations = enabledConstellations.filter(c => !prevSet.has(c));
        if (newConstellations.length > 0) {
          // Add new constellations to the filter
          return [...prev, ...newConstellations];
        }
        // Otherwise, keep user's selection
        return prev;
      }
      
      // Default: set to all enabled constellations
      return [...enabledConstellations];
    });
  }, [enabledConstellations, activeTab]);

  // For tasking tab: Remove constellations from filter that are no longer available (e.g., due to resolution filter)
  useEffect(() => {
    if (activeTab === 'task') {
      setConstellationFilter(prev => {
        // If no constellations are available, clear the filter
        if (taskConstellations.length === 0) {
          return [];
        }
        
        // Filter out any constellations that are no longer in taskConstellations
        const availableSet = new Set(taskConstellations);
        const filtered = prev.filter(c => availableSet.has(c));
        
        // If all selected constellations were removed (but new ones are available), reset to all available
        if (filtered.length === 0 && taskConstellations.length > 0) {
          return [...taskConstellations];
        }
        
        // If filter is empty and we have available constellations, set to all available
        if (prev.length === 0 && taskConstellations.length > 0) {
          return [...taskConstellations];
        }
        
        return filtered;
      });
    }
  }, [taskConstellations, activeTab]);

  useEffect(() => {
    setShowDraftOption(
      imageryData &&
      imageryData.length > 0 &&
      (selectedImages || selectedImages.length === 0)
    );
  }, [imageryData, selectedImages]);

  const getGuidanceMessage = () => {
    if (!drawnCoordinates) {
      return {
        message: "Draw an Area of Interest (AOI) on the map to begin",
        icon: <Target size={42} color="#2E90FA" style={{animation: 'pulse 2s infinite'}} />
      };
    }
    if (!formData.startDate || !formData.endDate) {
      return {
        message: "Select a date range to search for available imagery",
        icon: <Calendar size={100} color="#2E90FA" style={{animation: 'pulse 2s infinite'}} />
      };
    }
    if (loading && activeTab === 'catalog') {
      return {
        message: "Searching for available imagery...",
        icon: <Loader2 size={42} color="#2E90FA" style={{animation: 'spin 1s linear infinite'}} />
      };
    }
    if (imageryData && imageryData.length === 0 && formData.startDate && formData.endDate && activeTab === 'catalog') {
      return {
        message: "No imagery found for the selected area and date range",
        icon: <Map size={42} color="#A6B6CE" />
      };
    }
    return null;
  };

  const guidance = getGuidanceMessage();

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  // const handleDateChange = (fieldName, value) => {
  //   if (!drawnCoordinates) return;
  //
  //   const isCatalog = activeTab === 'catalog';
  //   const formDates = isCatalog ? catalogDates : taskDates;
  //   const newFormData = { ...formDates, [fieldName]: value };
  //
  //   if (isCatalog) {
  //     setCatalogDates(newFormData);
  //   } else {
  //     setTaskDates(newFormData);
  //   }
  //
  //   // Only trigger on endDate change
  //   // if (fieldName === 'endDate' && newFormData.startDate && newFormData.endDate) {
  //   //   onDateRangeChange(newFormData);
  //   // }
  //     if (newFormData.startDate && newFormData.endDate) {
  //         onDateRangeChange(newFormData);
  //       }
  // };
const handleDateChange = (fieldName, value) => {
  if (!drawnCoordinates) {
    console.log('⚠️ No AOI yet, ignoring date change');
    return;
  }

  // Update the centralized dateRange by calling the parent's handler
  const currentDates = dateRange || { startDate: '', endDate: '' };
  const newFormData = { ...currentDates, [fieldName]: value };

  if (newFormData.startDate && newFormData.endDate) {
    console.log('📅 Triggering onDateRangeChange due to date input');
    onDateRangeChange(newFormData);
  }
};

  const calculateSummary = () => {
    if (!selectedImages || selectedImages.length === 0) {
      return {
        count: 0,
        constellations: [],
        avgCloud: 0,
        coverage: 0
      };
    }

    const uniqueSatellites = [...new Set(selectedImages.map(img => img.satellite))];
    return {
      count: selectedImages.length,
      constellations: uniqueSatellites,
      avgCloud: selectedImages.reduce((sum, img) => sum + img.cloud_cover, 0) / selectedImages.length,
      coverage: selectedImages.reduce((sum, img) => sum + (img.coverage_percentage || 0), 0)
    };
  };

  const summary = calculateSummary();
  const today = new Date().toISOString().split('T')[0];

  function computeOverallCoverage() {
    const aoiPolygon = getAOIPolygon();
    const aoiArea = aoiPolygon ? turf.area(aoiPolygon) : 0;
    if (!aoiPolygon || aoiArea === 0) return 0;
    const intersections = selectedImages.map(tile => {
      const tilePolygon = getTilePolygon(tile);
      if (!tilePolygon) return null;
      try {
        const intersection = turf.intersect(turf.featureCollection([aoiPolygon, tilePolygon]));
        return intersection;
      } catch (error) {
        console.error("Error computing intersection", error);
        return null;
      }
    }).filter(intersection => intersection !== null);
    if (intersections.length === 0) return 0;
    let unionPoly = intersections[0];
    for (let i = 1; i < intersections.length; i++) {
      unionPoly = turf.union(turf.featureCollection([unionPoly, intersections[i]]));
    }
    if (!unionPoly) return 0;
    const unionArea = turf.area(unionPoly);
    return (unionArea / aoiArea) * 100;
  }

  const computeTaskingData = () => {
    // Get the AOI polygon (assuming getAOIPolygon is defined in this file)
    const aoiPolygon = getAOIPolygon();
    const aoiArea =
      aoiPolygon ? (turf.area(aoiPolygon) / 1000000).toFixed(2) : '0'; // area in sqkm
    return {
      constellationName: taskingSelection?.constellation?.name || '',
      resolution: taskingSelection?.constellation?.resolution || '',
      cloudCover: summary.avgCloud ? summary.avgCloud.toFixed(2) + '' : '10',
      offNadirAngle: 0,
      aoiArea: aoiArea,
      coordinates : taskingSelection?.details?.opportunities?.map(opportunity => opportunity.footprint_coordinates)||"",
      aoiCoverage: taskingSelection ? taskingSelection?.details?.areaCoverage : '0%',
      estimatedTimeToCapture: taskingSelection?.details?.captureTimeRange || ''
    };
  };

  useEffect(() => {
    if (activeTab === 'task' && typeof onTaskingDataUpdate === 'function' && taskingSelection) {
      const taskingData = computeTaskingData();
      onTaskingDataUpdate(taskingData);
    }
  }, [activeTab, taskingSelection, drawnCoordinates]);
  const handleResetFilters = () => {
      // Sensor type
      setSensorType([]);
      setCommittedSensorType([]);

      // Sliders
        if (activeTab === "catalog") {
          setResolutionRange([0, 50]);
          setCommittedResolutionRange([0, 50]);
        } else {
          setResolutionRange([0, 3]);
          setCommittedResolutionRange([0, 3]);
      }

      setMaxCloudCover(100);
      setMaxOffNadirAngle(25);
      setCommittedMaxOffNadirAngle(25);

      setMaxSunElevation(0);
      setCommittedMaxSunElevation(0);

      // Constellations
      setConstellationFilter([]);

      // Trigger update only if polygon + dates exist
      if (formData.startDate && formData.endDate && drawnCoordinates) {
        onDateRangeChange(formData);
        }
};

    useEffect(() => {
      if (typeof onRegisterReset === "function") {
        onRegisterReset(handleResetFilters);
      }
    }, [handleResetFilters]);
  // Reset tasking selection when committed filters change (for tasking tab)
  // Using committed values prevents resets during slider dragging
  useEffect(() => {
    if (activeTab === 'task') {
      setTaskingSelection(null);
    }
  }, [activeTab, committedResolutionRange, committedMaxOffNadirAngle, committedMaxSunElevation, committedSensorType, committedAcquisitionMode]);

  // Date range management is now handled by parent (ExplorePage)
  // The parent sets default dates when tabs switch, so we don't need to do it here
  // We just use the dateRange prop that's passed down

  if (activeTab === 'aois') {
    return (
      <SavedAOIs
        drawnCoordinates={drawnCoordinates}
        onAOISelect={onAOISelect}
      />
    );
  }

  // Compute overall AOI coverage from selected tiles by summing their individual percentages
  const totalCoverage = selectedImages.reduce((acc, tile) => {
    return acc + calculateTileCoverage(tile);
  }, 0);

  // Helper: Convert tile coordinates to a Turf polygon
  function getTilePolygon(tile) {
    if (!tile.coordinates || tile.coordinates.length === 0) return null;
    const tileCoords = tile.coordinates[0];
    if (tileCoords.length < 3) {
      console.warn('Tile coordinates do not have enough points to form a valid polygon', tile);
      return null;
    }
    // Ensure the polygon is closed
    if (
      tileCoords[0][0] !== tileCoords[tileCoords.length - 1][0] ||
      tileCoords[0][1] !== tileCoords[tileCoords.length - 1][1]
    ) {
      tileCoords.push(tileCoords[0]);
    }
    if (tileCoords.length < 4) return null;
    return turf.polygon([tileCoords]);
  }

  // Handle export feasibility - opens modal for XLSX selection
  const handleExportFeasibility = () => {
    if (constellationsWithStrips.length === 0) {
      return;
    }
    // Start with all unselected
    setSelectedConstellationsForExport([]);
    setExportFormat('xlsx'); // Default to XLSX
    setShowExportModal(true);
  };

  // Direct CSV export - exports all constellations without selection
  const handleDirectCSVExport = async () => {
    try {
      const token = localStorage.getItem('token');

      // Prepare all constellations data for export
      const constellationsData = constellationsWithStrips.map(constellation => ({
        constellation: constellation.name,
        opportunities: constellation.opportunities ?? [],
        timezone: constellation.timezone || 'UTC',
      })).filter(c => c.opportunities.length > 0);

      if (constellationsData.length === 0) {
        return;
      }

      // Export all constellations in a single CSV file
      const response = await fetch(SEARCH_URLS.downloadFeasibilityCSVCombined, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          constellations: constellationsData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ detail: 'Failed to generate export' }));
        throw new Error(errorData.detail || 'Failed to generate feasibility export.');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const formattedDate = new Date().toISOString().split('T')[0];
      const filename = `feasibility_export_${formattedDate}.csv`;
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setShowExportModal(false);
      setSelectedConstellationsForExport([]);
    } catch (error) {
      console.error('Error exporting feasibility:', error);
    }
  };

  // Handle actual export after selection - XLSX only (CSV is handled directly)
  const handleConfirmExport = async () => {
    if (selectedConstellationsForExport.length === 0) {
      return;
    }

    try {
      const token = localStorage.getItem('token');

      // Prepare constellations data for export
      const constellationsData = selectedConstellationsForExport.map(constellationName => {
        const constellationData = constellationsWithStrips.find(c => c.name === constellationName);
      return {
          constellation: constellationName,
          opportunities: constellationData?.opportunities ?? [],
          timezone: constellationData?.timezone || 'UTC',
      };
      }).filter(c => c.opportunities.length > 0); // Only include constellations with opportunities

      if (constellationsData.length === 0) {
        return;
      }

      // Export all constellations in a single XLSX file (multiple sheets)
      const response = await fetch(SEARCH_URLS.downloadFeasibilityXLSX, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          constellations: constellationsData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ detail: 'Failed to generate export' }));
        throw new Error(errorData.detail || 'Failed to generate feasibility export.');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const formattedDate = new Date().toISOString().split('T')[0];
      const filename = `feasibility_export_${formattedDate}.xlsx`;
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setShowExportModal(false);
      setSelectedConstellationsForExport([]);
    } catch (error) {
      console.error('Error exporting feasibility:', error);
    }
  };

  const renderSummaryContent = () => {
    // If feasibility is being checked, show loading or empty state
    if (activeTab === 'task' && loadingConstellation) {
      return [
        ['Constellations:', '-'],
        ['Estimated No. of strips:', '-'],
        ['% Area covered of AOI:', '-'],
        ['Estimated Time to Capture:', '-']
      ];
    }

    // If a constellation is selected and has details, show those details
    if (activeTab === 'task' && taskingSelection) {
      const { constellation, details } = taskingSelection;
      return [
        ['Constellations:', constellation?.name || '-'],
        ['Estimated No. of strips:', details?.opportunities?.length || '-'],
        ['% Area covered of AOI:', details?.areaCoverage || '-'],
        ['Estimated Time to Capture:', details?.captureTimeRange || '-']
      ];
    }

    // Default case for catalog tab or no selection
    return [
      ['No. of images:', summary.count || '-'],
      ['Constellations:', summary.constellations.join(', ') || '-'],
//      ['Avg. Cloud Cover:', `${summary.avgCloud.toFixed(2)}%`],
      ['% Area covered of AOI:', `${overallCoverage.toFixed(2)}%`]
    ];
  };

  // Modify the Summary Section buttons
  const renderActionButtons = () => {
    const isHackathonUser = userRole && userRole.toLowerCase() === 'hackathon';

    if (activeTab === 'task') {
      return (
        <>
        <div
          style={{
            fontSize: '13px',
            fontStyle: 'italic',
            color: '#A6B6CE',
            marginBottom: '12px',
            opacity: 0.8,
          }}
        >
            Disclaimer: All estimates are subject to change.
          </div>
    <button
          onClick={handleExportFeasibility}
          disabled={constellationsWithStrips.length === 0}
      style={{
        width: '100%',
            backgroundColor: constellationsWithStrips.length > 0 ? '#2E90FA' : '#666666',
            color: '#ffffff',
        padding: '12px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
            cursor: constellationsWithStrips.length > 0 ? 'pointer' : 'not-allowed',
            opacity: constellationsWithStrips.length > 0 ? 1 : 0.5,
        fontWeight: '500',
            transition: 'all 0.3s ease',
      }}
    >
          {constellationsWithStrips.length > 0
            ? 'Export Feasibility'
            : 'No constellations with strips available'}
    </button>
        </>
      );
    }

    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        {showDraftOption && (
          <button
            onClick={onSaveDraft}
            disabled={saveLoading || !selectedImages.length || isHackathonUser}
            style={{
              flex: 1,
              backgroundColor: 'transparent',
              color: isHackathonUser ? '#999' : '#2E90FA',
              padding: '12px',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              cursor: (saveLoading || !selectedImages.length || isHackathonUser) ? 'not-allowed' : 'pointer',
              fontWeight: '500',
              opacity: (saveLoading || !selectedImages.length || isHackathonUser) ? 0.5 : 1,
              transition: 'opacity 0.3s ease'
            }}
          >
            {saveLoading ? 'Saving...' : 'Save order as draft'}
          </button>
        )}
        <button
          onClick={onCheckOut}
          disabled={!selectedImages.length || isHackathonUser}
          style={{
            flex: 1,
            backgroundColor: (selectedImages.length && !isHackathonUser) ? '#2E90FA' : '#666666',
            color: '#ffffff',
            padding: '12px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: (selectedImages.length && !isHackathonUser) ? 'pointer' : 'not-allowed',
            opacity: (selectedImages.length && !isHackathonUser) ? 1 : 0.5,
            fontWeight: '500',
            transition: 'all 0.3s ease'
          }}
        >
          Check Out
        </button>
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', color: '#A6B6CE' }}>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.1; }
            100% { opacity: 1; }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
                      /* This targets the calendar icon in date inputs in supported browsers */
          input[type="date"]::-webkit-calendar-picker-indicator {
            filter: invert(1);
            opacity: 1;
            cursor: pointer;
          }
          
          /* This is for Firefox and other browsers */
          input[type="date"] {
            color-scheme: light;
          }
        `}
      </style>

      {/* Guidance Message at the top when no AOI is drawn */}
      {!drawnCoordinates && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          textAlign: 'center',
          backgroundColor: 'rgba(46, 144, 250, 0.05)',
          borderRadius: '8px',
          margin: '10px 16px',
          border: '1px solid rgba(46, 144, 250, 0.2)'
        }}>
          <div style={{ fontSize: '32px', marginBottom: '16px' }}>
            <Target size={42} color="#2E90FA" style={{animation: 'pulse 2s infinite'}} />
          </div>
          <div style={{ fontSize: '20px', color: '#A6B6CE',animation: 'pulse 2s infinite' }} >
            Draw an Area of Interest (AOI) on the map to begin
          </div>
        </div>
      )}

        {/* Date Range and Filters */}
        <div
          style={{
            padding: '10px 10px 10px 16px',
            borderBottom: '1px solid #00000080',
            opacity: drawnCoordinates ? 1 : 0.5,
            pointerEvents: drawnCoordinates ? 'auto' : 'none',
            transition: 'opacity 0.3s ease',
            position: 'relative',

          }}>
        <div style={{ display: 'flex', alignItems: 'center', flex: '0 0 75%' }}>
                <DateRangePicker
                  dateRange={formData}
                  handleDateRangeChange={onDateRangeChange}
                  activeTab={activeTab}
                />
                {/*<div style={{*/}
                {/*  display: 'flex',*/}
                {/*  alignItems: 'center',*/}
                {/*  backgroundColor: '#5A5A5A',*/}
                {/*  padding: '6px 10px',*/}
                {/*  borderRadius: '6px',*/}
                {/*  gap: '8px',*/}
                {/*}}>*/}
                {/*  <span style={{ fontSize: '14px', color: '#FFFFFF', fontWeight: 'bold' }}>Date Range</span>*/}

                {/*  /!* 🗓 Start Date *!/*/}
                {/*<DatePicker*/}
                {/*  selected={formData.startDate ? new Date(formData.startDate) : null}*/}
                {/*  onChange={(date) => handleDateChange('startDate', date.toISOString().split('T')[0])}*/}
                {/*  placeholderText="Start"*/}
                {/*  dateFormat="dd/MM/yyyy"*/}
                {/*  className="dark-datepicker-input"*/}
                {/*  calendarClassName="dark-calendar"*/}
                {/*  showMonthDropdown*/}
                {/*  showYearDropdown*/}
                {/*  dropdownMode="select"*/}
                {/*/>*/}
                {/*  <span*/}
                {/*    style={{*/}
                {/*      color: '#FFFFFF',*/}
                {/*      fontWeight: 'bold',*/}
                {/*      fontSize: '13px',*/}
                {/*      opacity: 0.8,*/}
                {/*    }}*/}
                {/*  >*/}
                {/*    to*/}
                {/*  </span>*/}
                {/*  /!* 🗓 End Date *!/*/}
                {/*<DatePicker*/}
                {/*  selected={formData.endDate ? new Date(formData.endDate) : null}*/}
                {/*  onChange={(date) => handleDateChange('endDate', date.toISOString().split('T')[0])}*/}
                {/*  placeholderText="End"*/}
                {/*  dateFormat="dd/MM/yyyy"*/}
                {/*  className="dark-datepicker-input"*/}
                {/*  calendarClassName="dark-calendar"*/}
                {/*  showMonthDropdown*/}
                {/*  showYearDropdown*/}
                {/*  dropdownMode="select"*/}
                {/*/>*/}
                {/*</div>*/}

                    {/*</div>*/}


          {/* 🔍 Search Button (replaces All Filters) */}
          <div
            style={{
              flex: '0 0 23%',
              display: 'flex',
              justifyContent: 'flex-end',
              position: 'relative',
            }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                    // CRITICAL: Check activeTab FIRST and return immediately if tasking
                    // This prevents ANY possibility of calling search API on tasking tab
                    if (activeTab === 'task') {
                      console.log('🛑 [TASKING TAB] Search button clicked - BLOCKING search API call');
                      // Clear selections when starting a new search
                      if (clearSelectionsRef.current) {
                        console.log('🧹 [TASKING] Clearing strip selections');
                        clearSelectionsRef.current();
                      }
                      // Don't reset filters for tasking tab - keep current filter values (25, 0)
                      // handleResetFilters(); // REMOVED - this was resetting maxOffNadirAngle to 90 and maxSunElevation to 90
                      if (formData?.startDate && formData?.endDate && drawnCoordinates) {
                  onDateRangeChange(formData);
                        setTimeout(() => {
                          if (feasibilityTriggerRef.current) {
                            console.log('🚀 [TASKING] Triggering feasibility checks');
                            feasibilityTriggerRef.current();
                          } else {
                            console.error('❌ [TASKING] Feasibility trigger not available');
                          }
                        }, 50);
                      }
                      return; // HARD STOP - never proceed past this point for tasking tab
                    }
                    
                    // Only reach here if NOT tasking tab (catalog tab)
                    console.log('📚 [CATALOG TAB] Search button clicked - will call search API');
                    handleResetFilters();
                    if (formData?.startDate && formData?.endDate && drawnCoordinates) {
                      onDateRangeChange(formData);
                      if (onSearch) {
                        console.log('🚀 [CATALOG] Calling onSearch API');
                        onSearch(drawnCoordinates, formData);
                      }
                }
              }}              sx={{
                width: '90%',
                height: '90%',
                backgroundColor: '#2E90FA',
                color: 'white',
                fontSize: '13px',
                textTransform: 'none',
                borderRadius: '6px',
                py: 1,
                '&:hover': { backgroundColor: '#2579d6' },
              }}
            >
              Search
            </Button>
          </div>

        {/* Filters Button */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 1,
            position: 'relative',
            zIndex: 9999, // ensures tooltip appears on top
          }}
        >
          <Tooltip
            title="All Filters"
            arrow
            PopperProps={{
              sx: { zIndex: 99999 }, // force tooltip to appear above other layers
            }}
          >
            <IconButton
              size="small"
              onClick={() => setShowFilters(!showFilters)}
              sx={{
                p: 0.5,
                color: '#A6B6CE',
                '&:hover': { color: '#2E90FA', backgroundColor: 'transparent' },
              }}
            >
              <SlidersHorizontal size={20} />
            </IconButton>
          </Tooltip>
        </Box>
        </div>
        {/* Filters Dropdown */}
        {showFilters && (
          <Box
          sx={{
            position: 'absolute',
              right: 20,
              top: 'calc(100% + 8px)',
            width: 320,
            bgcolor: '#1F1F1F',
            borderRadius: '6px',
            p: 2,
            zIndex: 100,
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
          }}
          >
            {/* Sensor Type Section */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                mb: 2,
              }}
            >
              {/* 🟦 Selected Chips */}
              {Array.isArray(sensorType) && sensorType.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                  {sensorType.map((type) => (
                    <Box
                      key={type.value || type}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#2B2B2B',
                        borderRadius: '6px',
                        padding: '2px 8px',
                        color: '#A6B6CE',
                        fontSize: '12px',
                      }}
                    >
                      {type.label || type.toUpperCase?.() || type}
                      <Box
                        component="button"
                        onClick={() =>
                          setSensorType((prev) =>
                            prev.filter(
                              (t) =>
                                (t.value || t) !== (type.value || type)
                            )
                          )
                        }
                        sx={{
                          background: 'transparent',
                          border: 'none',
                          color: '#A6B6CE',
                          cursor: 'pointer',
                          fontSize: '12px',
                          marginLeft: '6px',
                          '&:hover': { color: '#fff' },
                        }}
                        title={`Unselect ${type.label || type}`}
                      >
                        ✕
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Dropdown Row */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2,
          }}
              >
                {/* Dropdown + Clear All */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              width: 180,
              backgroundColor: '#2B2B2B',
              borderRadius: '6px',
              padding: '4px 6px',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <CustomDropdown
                value={sensorType}
                onChange={(val) => {
                        const newSensorType = (() => {
                          const prevArr = Array.isArray(sensorType) ? sensorType : [];

                          // Case 1: If dropdown sends back an array (like react-select multi)
                          if (Array.isArray(val)) {
                            return val;
                          }

                          // Case 2: Dropdown sends only the clicked item (single option)
                          const incoming = getVal(val);
                          const exists = prevArr.some((item) => getVal(item) === incoming);

                          if (exists) {
                            // Deselect
                            return prevArr.filter((item) => getVal(item) !== incoming);
                          } else {
                            // Select
                            return [...prevArr, val];
                          }
                        })();

                        setSensorType(newSensorType);
                        setCommittedSensorType(newSensorType); // Update committed value immediately for dropdown

                        // Fire callback if date and polygon are present
                  if (formData.startDate && formData.endDate && drawnCoordinates) {
                    onDateRangeChange(formData);
                  }
                }}
                options={[
                  { value: 'optical', label: 'Optical' },
                  { value: 'sar', label: 'SAR' },
                  // { value: 'NDVI', label: 'NDVI' },
                ]}
                placeholder="Sensor Type"
                disabled={!drawnCoordinates}
              />
            </Box>

                  {/* ❌ Clear All */}
            {sensorType?.length > 0 && (
              <button
                      onClick={() => {
                        setSensorType([]);
                        setCommittedSensorType([]);
                      }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#A6B6CE',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: 0,
                }}
                      title="Clear all selections"
              >
                ✕
              </button>
            )}
          </Box>

                {/* ❌ Close Filters */}
          <button
            onClick={() => setShowFilters(false)}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#A6B6CE',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: 'bold',
              padding: '4px',
              marginLeft: 'auto',
              alignSelf: 'flex-start',
            }}
            title="Close Filters"
          >
            ✕
          </button>
              </Box>
        </Box>


        {/* Common Sliders */}
        {[
              { label: 'Resolution (m)', value: resolutionRange, setter: setResolutionRange, min: 0, max: activeTab === "catalog" ? 50 : 3, isRange: false, unit: "m" },
              ...(activeTab === 'catalog' ? [{ label: 'Max Cloud Cover (%)', value: maxCloudCover, setter: setMaxCloudCover, min: 0, max: 100, unit: '%' }] : []),
              // Max Off-Nadir: 0–25°
              { label: 'Max Off-Nadir Angle (°)', value: maxOffNadirAngle, setter: setMaxOffNadirAngle, min: 0, max: 25, unit: '°' },
              // Min Sun Elevation: 0–90° (simple min filter, value = min sun)
              { label: 'Min Sun Elevation (°)', value: maxSunElevation, setter: setMaxSunElevation, min: 0, max: 90, unit: '°' },
        ].map((f) => (
          <Box
            key={f.label}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 2,
                  gap: 1,
            }}
          >
                {/* Label */}
                <span style={{ fontSize: '12px', color: '#A6B6CE', minWidth: 110 }}>
                  {f.label}
                </span>

                {/* Slider + value display */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Slider
              value={f.value}
              onChange={(_, val) => {
                f.setter(val);
              }}
                    onChangeCommitted={(_, val) => {
                      // Update committed filter value when user releases the slider
                      if (f.label === 'Resolution (m)') {
                        setCommittedResolutionRange(val);
                      } else if (f.label === 'Max Off-Nadir Angle (°)') {
                        setCommittedMaxOffNadirAngle(val);
                      } else if (f.label === 'Min Sun Elevation (°)') {
                        setCommittedMaxSunElevation(val);
                      }
                      // Only trigger actions when user releases the slider
                if (formData.startDate && formData.endDate && drawnCoordinates) {
                  onDateRangeChange(formData);
                }
              }}
              min={f.min}
              max={f.max}
              step={1}
              valueLabelDisplay="auto"
              valueLabelFormat={(val) => `${val}${f.unit || ''}`}
              sx={{
                color: '#2E90FA',
                width: 140,
                '& .MuiSlider-thumb': {
                  width: f.isRange ? 10 : 12,
                  height: f.isRange ? 10 : 12,
                },
                '& .MuiSlider-track': {
                  height: 4,
                  // For Min Sun Elevation, grey from left -> thumb (deselected)
                  ...(f.label === 'Min Sun Elevation (°)'
                    ? { backgroundColor: '#1f2933' }
                    : {}),
                },
                '& .MuiSlider-rail': {
                  height: 4,
                  // For Min Sun Elevation, blue from thumb -> right (selected)
                  ...(f.label === 'Min Sun Elevation (°)'
                    ? { backgroundColor: '#2E90FA' }
                    : {}),
                },
              }}
            />

                  {/* ✅ Display current value */}
                  <span style={{ fontSize: '12px', color: '#A6B6CE', minWidth: 40, textAlign: 'right' }}>
                    {Array.isArray(f.value)
                      ? `${f.value[0]} - ${f.value[1]}${f.unit || ''}`
                      : `${f.value}${f.unit || ''}`}
                  </span>
          </Box>
              </Box>
        ))}

        {/* Constellation Filter */}
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(255,255,255,0.5)",
            margin: "12px 0"
          }}
        />
        <ConstellationFilter
          availableConstellations={availableConstellations}
          enabledConstellations={enabledConstellations}
          selectedConstellations={constellationFilter}
          activeTab={activeTab}
          onToggle={(name, checked) => {
            setConstellationFilter((prev) =>
              checked ? [...prev, name] : prev.filter((n) => n !== name)
            );

            if (activeTab === "catalog") {
              onSatelliteVisibilityToggle?.(name, checked);
            }

            if (activeTab === "task") {
              handleTaskConstellationToggle(name, checked);
            }
          }}
        />

            {/* 🛰 Satellite Legend */}
            {/*<SatelliteLegend*/}
            {/*  groupedItems={groupedItems}*/}
            {/*  satelliteSelections={satelliteSelections}*/}
            {/*  handleSelectAllForSatellite={handleSelectAllForSatellite}*/}
            {/*  satelliteColors={satelliteColors}*/}
            {/*/>*/}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <button
                onClick={handleResetFilters}
                style={{
                  background: 'transparent',
                  border: '1px solid #444',
                  color: '#A6B6CE',
                  cursor: 'pointer',
                  fontSize: '12px',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  opacity: 0.8,
                }}
                onMouseEnter={(e) => (e.target.style.opacity = 1)}
                onMouseLeave={(e) => (e.target.style.opacity = 0.8)}
              >
                Reset
              </button>
      </Box>
      </Box>

    )}

  </div>
{/*</div>*/}

      {/* Main Content Area */}
      <div style={{
        flex: 1,
        padding: '0 16px',
        borderBottom: activeTab === 'task' ? 'none' : '1px solid #00000080',
        minHeight: '200px',
        maxHeight: activeTab === 'task' ? 'none' : 'calc(100vh - 400px)',
        overflow: activeTab === 'task' ? 'hidden' : 'auto',
        display: 'flex',
        flexDirection: 'column',
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(255,255,255,0.1) transparent',
        '&::-webkit-scrollbar': {
          width: '2px',
          backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '1px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: 'rgba(255,255,255,0.2)'
        }
      }}>
        {/* Scrollable content wrapper for tasking */}
        {activeTab === 'task' ? (
          <div style={{ flex: 1, overflow: 'auto', paddingBottom: '16px' }}>
            {drawnCoordinates && guidance ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                textAlign: 'center',
                color: '#A6B6CE',
                padding: '20px'
              }}>
                <div style={{ fontSize: '32px', marginBottom: '16px' }}>{guidance.icon}</div>
                <div style={{ fontSize: '20px' }}>{guidance.message}</div>
              </div>
            ) : error ? (
              <div style={{
                color: '#FF4D4F',
                padding: '10px',
                backgroundColor: 'rgba(255,77,79,0.1)',
                borderRadius: '4px',
                textAlign: 'center',
                margin: '10px'
              }}>
                {error}
              </div>
            ) : (
              <TaskingConstellations
                dateRange={formData}
                drawnCoordinates={drawnCoordinates}
                onFootprintSelect={onFootprintSelect}
                onSelectionChange={setTaskingSelection}
                loadingHandler={(loading) => setLoadingConstellation(loading)}
                filterKey={`${JSON.stringify(committedResolutionRange)}-${committedMaxOffNadirAngle}-${committedMaxSunElevation}-${JSON.stringify(committedSensorType)}-${committedAcquisitionMode}`}
                isDrawing={isDrawing}
                constellationFilter={constellationFilter}
                onConstellationsUpdate={setTaskConstellations}
                onEnabledConstellationsUpdate={setEnabledTaskConstellations}
                onConstellationsWithStripsUpdate={setConstellationsWithStrips}
                resolutionRange={committedResolutionRange}
                maxOffNadirAngle={committedMaxOffNadirAngle}
                maxSunElevation={committedMaxSunElevation}
                isRestoringTaskingState={isRestoringTaskingState}
                onTaskingStateReady={onTaskingStateReady}
                cachedTaskingState={cachedTaskingState}
                onFeasibilityTriggerReady={(triggerFn) => {
                  feasibilityTriggerRef.current = triggerFn;
                  // Also expose to parent (ExplorePage) if callback provided
                  if (onFeasibilityTriggerReady) {
                    onFeasibilityTriggerReady(triggerFn);
                  }
                }}
                onClearSelectionsReady={(clearFn) => {
                  clearSelectionsRef.current = clearFn;
                  // Also expose to parent (ExplorePage) if callback provided
                  if (onClearSelectionsReady) {
                    onClearSelectionsReady(clearFn);
                  }
                }}
              />
            )}
          </div>
        ) : (
          <>
        {/* Error Handling and Guidance - Now we only show guidance here for non-AOI messages */}
        {drawnCoordinates && guidance ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            textAlign: 'center',
            color: '#A6B6CE',
            padding: '20px'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '16px' }}>{guidance.icon}</div>
            <div style={{ fontSize: '20px' }}>{guidance.message}</div>
          </div>
        ) : error ? (
          <div style={{
            color: '#FF4D4F',
            padding: '10px',
            backgroundColor: 'rgba(255,77,79,0.1)',
            borderRadius: '4px',
            textAlign: 'center',
            margin: '10px'
          }}>
            {error}
          </div>
        ) : (
            <CatalogImagery
              items={getFilteredImagery()}
                constellationFilter={constellationFilter}
              onImageSelect={onImageSelect}
              onVisibilityToggle={onImageVisibilityToggle}
              onSatelliteVisibilityToggle={onSatelliteVisibilityToggle}
              onImageHover={onImageHover}
              visibleImage={visibleImage}
              drawnCoordinates={drawnCoordinates}
  onSatelliteDataUpdate={({ groupedItems, satelliteSelections, handleSelectAllForSatellite, satelliteColors }) => {
    setGroupedItems(groupedItems);
    setSatelliteSelections(satelliteSelections);
    setHandleSelectAllForSatellite(() => handleSelectAllForSatellite);
    setSatelliteColors(satelliteColors);
  }}
            />
            )}
          </>
        )}
      </div>

      {/* Summary Section - Hidden for tasking tab */}
      {activeTab !== 'task' && (
      <div style={{ padding: '16px', marginTop: 'auto' }}>
        <h3 style={{
          fontSize: '16px',
          color: '#A6B6CE',
          fontWeight: 'normal',
          marginBottom: '12px',
          marginTop: '4px'
        }}>
          Your Selection
        </h3>

        <div style={{ marginBottom: '16px' }}>
          {renderSummaryContent().map(([label, value]) => (
            <div key={label} style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '13px',
              color: '#A6B6CE',
              marginBottom: '4px'
            }}>
              <span>{label}</span>
              <span>{value}</span>
            </div>
          ))}
        </div>

        {renderActionButtons()}
      </div>
      )}

      {/* Export button for tasking tab - positioned at bottom */}
      {activeTab === 'task' && (
        <div style={{ padding: '0 16px 16px 16px', flexShrink: 0 }}>
          {renderActionButtons()}
        </div>
      )}

      {/* Export Feasibility Modal - Centered on entire screen using Portal */}
      {showExportModal && ReactDOM.createPortal(
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10001,
            margin: 0,
            padding: 0,
          }}
          onClick={() => {
            setShowExportModal(false);
            setSelectedConstellationsForExport([]);
          }}
        >
          <Box
            sx={{
              backgroundColor: 'hsl(0,0%,0%)',
              borderRadius: '10px',
              padding: '24px',
              width: '420px',
              maxHeight: '80vh',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography sx={{ color: 'white', fontSize: '18px', fontWeight: 600 }}>
                Export Pass Information
              </Typography>
              <IconButton
                onClick={() => {
                  setShowExportModal(false);
                  setSelectedConstellationsForExport([]);
                }}
                sx={{ 
                  color: 'rgba(255, 255, 255, 0.7)', 
                  padding: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                  },
                }}
              >
                ✕
              </IconButton>
            </Box>

            {/* Instruction Text */}
            <Typography sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '14px', mb: 2 }}>
              Select constellations to export (XLSX format - multiple sheets):
            </Typography>

            {/* Constellations List */}
            <Box sx={{ 
              mb: 2, 
              flex: 1,
              overflowY: 'auto',
              minHeight: '200px',
              maxHeight: '400px',
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(255,255,255,0.2)',
                borderRadius: '2px',
              },
            }}>
              {constellationsWithStrips.length === 0 ? (
                <Typography sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '14px', textAlign: 'center', py: 3 }}>
                  No constellations with strips available
                </Typography>
              ) : (
                constellationsWithStrips.map((constellation) => (
                  <Box
                    key={constellation.name}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: 1,
                      padding: '10px 12px',
                      borderRadius: '6px',
                      backgroundColor: selectedConstellationsForExport.includes(constellation.name) 
                        ? 'rgba(46, 144, 250, 0.2)' 
                        : 'transparent',
                      transition: 'background-color 0.2s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                      },
                    }}
                  >
                    <Checkbox
                      checked={selectedConstellationsForExport.includes(constellation.name)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedConstellationsForExport([...selectedConstellationsForExport, constellation.name]);
                        } else {
                          setSelectedConstellationsForExport(
                            selectedConstellationsForExport.filter(name => name !== constellation.name)
                          );
                        }
                      }}
                      sx={{
                        color: '#2E90FA',
                        padding: '4px',
                        '&.Mui-checked': {
                          color: '#2E90FA',
                        },
                      }}
                    />
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <Typography sx={{ color: 'white', fontSize: '14px' }}>
                        {constellation.name}
                      </Typography>
                      <Typography sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '12px', mt: 0.5 }}>
                        {constellation.opportunities?.length || 0} pass{constellation.opportunities?.length !== 1 ? 'es' : ''}
                      </Typography>
                    </Box>
                  </Box>
                ))
              )}
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
              <Button
                onClick={() => {
                  setShowExportModal(false);
                  setSelectedConstellationsForExport([]);
                }}
                sx={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  padding: '8px 20px',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDirectCSVExport}
                disabled={constellationsWithStrips.length === 0}
                sx={{
                  backgroundColor: '#2E90FA',
                  color: 'white',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  padding: '8px 20px',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#1E7AE8',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.4)',
                  },
                }}
              >
                Export All to CSV
              </Button>
              <Button
                onClick={handleConfirmExport}
                disabled={selectedConstellationsForExport.length === 0}
                sx={{
                  backgroundColor: '#2E90FA',
                  color: 'white',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  padding: '8px 20px',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#1E7AE8',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.4)',
                  },
                }}
              >
                Download XLSX
              </Button>
            </Box>
          </Box>
        </Box>,
        document.body
      )}
    </div>
  );
};

export default PanelContent;